/*
 * 文件EN: APILog.js,
 * 文件CN: 调用日志,
 * 创建时间: Wednesday, 17th June 2020 9:51:07 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import request from '@/plugins/http'
// import qs from 'qs'

/**
 * @desc 列表获取
 * @method GET
 * @param {参数说明 详细见 swagger}
 */
export const getListData = params => {
  return request.get('/apiManager/useLog/queryUseLog', params)
}

/**
 * @desc 详情
 * @method GET
 * @param {id 项目列表的id int类型}
 */
export const fetchDetails = params => {
  return request.get('/apiManager/useLog/queryUseLogDetail', params)
}
